/**
 * @param props.color : a hex color to set stroke or fills color of svg path
 * @param props.size : set the icon size, see getSize for expected values
 * @param props.className : a tailwind class the would be implemented on span tag
 */

interface ClipboardCloseProps {
    color?: string
    size?: string
    className?: string
}

const ClipboardClose = (props: ClipboardCloseProps) => {
    const { className = '', color = '#364152' } = props
    return (
        <span className={'flex items-center justify-center' + className}>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11.6666 13.4667L8.36664 10.1667" stroke={color} strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M11.6333 10.2L8.33331 13.5" stroke={color} strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M8.33335 4.99999H11.6667C13.3334 4.99999 13.3334 4.16666 13.3334 3.33332C13.3334 1.66666 12.5 1.66666 11.6667 1.66666H8.33335C7.50002 1.66666 6.66669 1.66666 6.66669 3.33332C6.66669 4.99999 7.50002 4.99999 8.33335 4.99999Z" stroke={color} strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M13.3333 3.35001C16.1083 3.50001 17.5 4.52501 17.5 8.33334V13.3333C17.5 16.6667 16.6667 18.3333 12.5 18.3333H7.5C3.33333 18.3333 2.5 16.6667 2.5 13.3333V8.33334C2.5 4.53334 3.89167 3.50001 6.66667 3.35001" stroke={color} strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
            </svg>

        </span>
    )
}

export default ClipboardClose
